import { Button, Box, Typography, useMediaQuery } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import "./Register.css";
import registerBgImg from "../../Assest/Images/registerBgImg.svg";
import registerSideImg from "../../Assest/Images/registerSideImg.svg";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import { useEffect, useCallback } from "react";
import { baseUrl, postData } from "../../BaseUrl";
import Routings from "../../Routings";
import useTranslations from "../Translations/useTranslations";

export default function Verify() {
  const { translations } = useTranslations();
  const isTab = useMediaQuery("(max-width:912px)");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const apiToken = searchParams.get("token");
  console.log("token", apiToken);
  const styles = {
    container: {
      backgroundColor: "#F9F6FF",
      paddingTop: "8rem",
      background: isTab ? "#F9F6FF" : `url(${registerBgImg})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      minHeight: isTab ? "100vh" : "100%",
    },
  };

  const apiCall = useCallback(async () => {
    try {
      await postData(`${baseUrl}auth/verify-email`, { token: apiToken });
    } catch (err) {
      console.error("Error:", err.message);
    }
  }, [apiToken]);

  useEffect(() => {
    apiCall();
  }, [apiCall]);

  return (
    <Box style={styles.container}>
      <div className="register-container">
        <div className="register-side">
          {!isTab && (
            <img
              className="registerImg"
              src={registerSideImg}
              alt="registerSideImg"
              style={{
                width: "100%",
                objectFit: "cover",
                display: "block",
                marginTop: "-2rem",
              }}
            />
          )}
        </div>
        <div
          className="register-form"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ marginTop: "-4rem" }}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              mb={2}
            >
              <Box
                bgcolor="primary.main"
                color="white"
                p={2}
                borderRadius="50%"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <CheckCircleIcon fontSize="large" />
              </Box>
            </Box>
            <Typography variant="h5" fontWeight="bold" color="text.primary">
              {translations.accountCreated}
            </Typography>
            <Typography variant="body1" color="text.secondary" mt={1}>
              {translations.welcomeMessage}
            </Typography>
            <Button
              variant="contained"
              type="submit"
              onClick={() => {
                apiCall();
                navigate(Routings.LOGIN);
              }}
              sx={{
                background: "linear-gradient(90deg, #4A7BA8, #244C77)",
                color: "#fff",
                fontSize: "16px",
                textTransform: "none",
                padding: "5px 30px",
                borderRadius: "20px",
                marginTop: "2rem",
              }}
            >
              {translations.startButtonText}
            </Button>
          </div>
        </div>
      </div>
    </Box>
  );
}
